import { Button } from "shared/ui/button";

import noScoreSvg from "../assets/no-score.svg";

type Props = {
  onClose: () => void;
};

export const NoScore = (props: Props) => {
  const { onClose } = props;
  return (
    <>
      <img src={noScoreSvg} className="h-[111px]" alt="not-found" />
      <h2 className="mt-5 text-center text-[21px] font-semibold whitespace-pre-line">
        {`We cannot locate your\nBlum sybil score`}
      </h2>

      <p className="text-balticSea/50 mt-12 text-center leading-[160%] font-medium">
        Make sure you have active account with history on Blum
      </p>

      <Button className="mt-auto w-full" onClick={onClose}>
        Close
      </Button>
    </>
  );
};
